import React, { useState } from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import usePatchHook from "../../customHooks/usePatchHook";
import Skeleton from "../../components/Reusable/Skeleton";
const EditStatusComponent = loadable(() => import("../../components/PickDrop"));
const PickDropEdit = () => {
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [defaultValue, setDefaultValue] = useState<any>([]);
  const handleEditStatusChange = (value: any) => {
    setDefaultValue(value);
  };
  const { data: statusList } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {},
  });
  const { data: gridData, isLoading } = useGetHook({
    queryKey: [`new-status`],
    url: `${APIS.PICK_STATUS}`,
    params: {
      is_active: true,
    },
  });

  const { mutateAsync, isLoading: patchLoading } = usePatchHook({
    queryKey: ["new-status"],
    navigateURL: "",
  });
  const handleOpenEditPopup = (item: any) => {
    setSelectedItem(item);
    setDefaultValue({
      value: item?.status_id,
      label: item?.status_name,
    });
    setOpenEditPopup(true);
  };

  const handleStatusInclude = async (event: any) => {
    event.preventDefault();
    const url = `${APIS.PICK_STATUS}${selectedItem?.id}/`;
    let formData = {
      status_id: defaultValue?.value,
    };
    try {
      const rest = await mutateAsync({ url, formData });
      if (rest.status === 200) {
        setOpenEditPopup(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      {isLoading ? (
        <Skeleton />
      ) : (
        <EditStatusComponent
          gridData={gridData}
          statusList={statusList}
          patchLoading={patchLoading}
          handleStatusInclude={handleStatusInclude}
          setSelectedItem={setSelectedItem}
          setOpenEditPopup={setOpenEditPopup}
          openEditPopup={openEditPopup}
          handleEditStatusChange={handleEditStatusChange}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
          handleOpenEditPopup={handleOpenEditPopup}
        />
      )}
    </>
  );
};
export default PickDropEdit;
